import { TmdxResourceCard } from '@features/components/ResourceCards';
import { CaseOCSConsoleResource, CaseResource } from '@/api/apis/case';
import { getConsoleSerialNumber } from '@/utils/helpers';
import { resourceLogisticsStatusNames } from '@/constants/resources.constants';

type CaseLogisticsDeviceInfoProps = {
  device: CaseResource<CaseOCSConsoleResource>;
};

export const CaseLogisticsDeviceInfo = ({ device }: CaseLogisticsDeviceInfoProps) => (
  <TmdxResourceCard
    size="sm"
    label="Actions"
    list={[]}
    type="device"
    title={getConsoleSerialNumber(device.data)}
    subTitle={device.data?.hub?.code}
    isReadOnly
    menuDisabled
    cardClassNames="min-w-full"
    chipProps={{
      status: device.logisticsStatus,
    }}
    chipText={resourceLogisticsStatusNames[device.logisticsStatus]}
    avatarProps={{
      type: 'device',
      organ: device.data?.organType,
      src: device.data?.logoPath,
    }}
  />
);
